import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {  INPUTS_PROPS, ADD_PARKER_ALLOCATION_STEPS } from "../../../../../enums/Enums";
import { DEFAULT_DIALING_CODE } from "../../../../../constants/Constants";
import Strings from "../../../../../resources/Strings";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
// import AddTokensFromListStep from "../Steps/AddTokensFromListStep";
import AddTokensWithFobStep from "../Steps/AddTokensWithFobStep";
import classes from "../WizardForm.module.css";
import { CarUserTokenOperationsEntity } from "../../../../../entities/ServicesEntities/UserEntities/CarUserTokenOperationsEntity";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import * as carUserTokenActionsService from "../../../../../services/ActionsService/CarUserTokenActionsService";
import store from "../../../../../redux/Store";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import SitesSelectInput from "../../../Inputs/CustomInputs/SitesSelectInput";
import UserTypeStep from "../../../Forms/Wizard Forms/Steps/UserTypeStep"
import {
  showErrorMessage,
  showUpdateSuccessMessage,
  showParkingAllocationSaveIsNotReadyMessage
} from "../../../../../utils/MessagesUtils";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { Button } from "@mui/material";
import Icons from "../../../../../resources/icons/Icons";
import { getScopeIdBySiteId, getCustomerRoleId, getSiteFromSiteId } from "../../../../../utils/UsersUtils";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import { getAddParkingAllocationBarValue } from "../../../../../utils/CommonUtils";
import AssignParkerAllocationStep from "../../../Forms/Wizard Forms/Steps/AssignParkerAllocationStep";
import AllocationManagementInfoStep from "../Steps/AllocationManagementInfoStep";
import { refreshSingleUserDataAndExtended } from "../../../../../services/ParkerService";

const AddParkerAllocationsForm = (props) => {
  const firstStep = ADD_PARKER_ALLOCATION_STEPS.ADD_TOKENS; //ADD_PARKER_ALLOCATION_STEPS.USER_TYPE;
  const allocations = useSelector((state) => state.allocations.allocations);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const [selectedSites, setSelectedSites] = useState(props.userData?.utronUser?.userSites?.map(us => us.site));
  const sites = useSelector((state) => state.user?.sites); // added

  const [isFobSkipped, setIsFobSkipped] = useState(false); // added

  const [isAddParkingAllocationInProcess, setIsAddParkingAllocationInProcess] = useState(false); // on process and on cancel
  const [isShowSaveChanges, setIsShowSaveChanges] = useState(false);
  const showExsistingParkingAllocation = useSelector((state) => state.common.showExsistingParkingAllocation);
  const showScanFobButton = useSelector((state) => state.common.showScanFobButton);
  const assigneOption = useSelector((state) => state.common.assigneOption);

  const AssignParkerAllocationStepRef = useRef();


  useEffect(() => {
    return () => {
      // unmount - on close reset assignOption - case site with fob
      store.dispatch(commonActions.setShowScanFobButton(true));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      store.dispatch(commonActions.setAssigneOption(null));
      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(true));
    }
  }, []);

  // const isSaveReady = () => {
  //   // when no change was made, and no selection
  //   if ((props?.userData?.carUserTokens?.length === formData?.carUserTokens?.length && assigneOption === null)
  //       || (props?.userData?.carUserTokens?.length === formData?.carUserTokens?.length && assigneOption === 2)) {
  //     showParkingAllocationSaveIsNotReadyMessage();
  //     return false;
  //   }

  //   // if ((props?.userData?.carUserTokens?.length === formData?.carUserTokens?.length) && assigneOption === 2) {
//   //   showParkingAllocationSaveIsNotReadyMessage();
  //   //   return false;
  //   // }

  //   return true;
  // }

  const isSaveReady = () => {
    if (isAddParkingAllocationInProcess) {
      showParkingAllocationSaveIsNotReadyMessage();
      return false;
    }

    return true;
  };

  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_ALLOCATION_STEPS.ADD_TOKENS, //ADD_PARKER_ALLOCATION_STEPS.USER_TYPE,
    totalSteps: 3,
    isCurrentStepValid: false,
  });

  const [formData, setFormData] = useState({
    dialingCode: DEFAULT_DIALING_CODE,
    token: "",
    fob: "",
    userType: "",
    isPaying: false,
    tokens: [],
    carUserTokens: [], // will hold the data to send
    // carUserTokens: props?.userData?.carUserTokens?.map((carToken) => {
    //   return {
    //     occupiedToken: carToken,
    //     fob: carToken?.carUserTokens.filter(
    //       (carUserToken) =>
    //         carUserToken?.userId === props?.userData?.utronUser?.id
    //     )[0]?.fob,
    //   };
    // }),
    isStepSubmitted: false,
    //selectedSite: selectedSites?.length > 0 ? selectedSites[0] : 0,
    site: selectedSites?.length > 0 ? selectedSites[0]?.id : 0,
    selectedSites: selectedSites,

    isAddAllocationProcess: true,
    userData: props?.userData,
    userSites: props?.userData?.utronUser?.userSites,

    // parker allocation
    selectedParker: props?.userData,
    showTemporaryTokenPreview: false,
    selectedAllocationToManage: null,
    
    // represents the allocations in ui, tokens associated with cars will be presented first  
    assignedParkerAllocations: allocations.filter(allocation => allocation.userId === props?.userData?.utronUser?.id).sort((a, b) => b.carId - a.carId),
    // assignedParkerAllocations: props?.userData?.utronUser?.carUserTokens?.filter(
    //   cut => cut.token?.userTypeId !== 1 && 
    //   cut.token?.deleted === false).map(assign => {
    //   // add site to token - to get the clientId for every site for image
    //   let assignCopy = { ...assign };
    //   let assignTokenCopy = { ...assign.token};
    //   let site = getSiteFromSiteId(sites, assign.token.siteId);

    //   assignTokenCopy.site = site;
    //   assignCopy.token = assignTokenCopy;

    //   return assignCopy;
    // }), // remove transient tokens
    foundedExistingParker: null // for existing usage
  });

  const handleChange = (newProp) => {
    if (newProp["assignedParkerAllocations"]) {
      let assignedParkerAllocationsCopy = [...newProp["assignedParkerAllocations"]];
      if (assignedParkerAllocationsCopy.some(allocation => allocation.uuid)) {
        // if any new / existing allocation created locate it on top
        newProp["assignedParkerAllocations"] = assignedParkerAllocationsCopy.sort((a, b) => a.uuid ? -1 : b.uuid ? 1 : 0);
      }
      else {
        // if theres is no new / existing allocation create set to initial sort (allocations associated with cars on top)
        newProp["assignedParkerAllocations"] = assignedParkerAllocationsCopy.sort((a, b) => b.carId - a.carId);
      }
    }

    setFormData({ ...formData, ...newProp });
  };

  const handleStateDataChange = (newProp) => {
    setStateData({ ...stateData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!isSaveReady()) {
      return;
    }


    const oldAssignedAllocationsIds = props?.userData?.carUserTokens?.map(
      (carUserToken) => carUserToken?.id
    );
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const { carUserTokens } = formData;

    if (stateData.isCurrentStepValid) {
      const carUserTokenOperationsEntity = new CarUserTokenOperationsEntity(
        props?.userData?.utronUser?.id,
        formData.site,
        props?.userData?.utronUser?.userToUserTypes?.find(
          (type) => type?.userType?.siteId === formData.site
        )?.userType?.id,
        carUserTokens?.filter(
          (carUserToken) =>
            !oldAssignedAllocationsIds?.includes(carUserToken?.token?.id)
        )
      );

      carUserTokenActionsService
        .assignCarUserToken(carUserTokenOperationsEntity, true, false)
        .then((response) => {
          if (response.data.isSuccess) {
            // prevents the sideModal to be reopened
            // (see: UserTypeStep, useEffect props.currentStep)
            // causes the stepHeader to be null, and prevents reopen
            stateData.currentStep--; 
            store.dispatch(commonActions.closeSideModal());
            actionsService
              .getUserSites()
              .then((response) => {
                store.dispatch(userActions.setSites(response.data.entity));
              })
              .then(() => {
                showUpdateSuccessMessage();
                 store.dispatch(userActions.setUsersScope(selectedScope.id));                
                const userId = props?.userData?.utronUser?.id;
                if (userId) {
                  refreshSingleUserDataAndExtended(userId).catch((error) => {
                    console.error('Error refreshing user data:', error);
                  });
                }
              });
          } else {
            showErrorMessage(response.data?.error);
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          }
        })
        .catch(error => {
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));           
        });
    }
  };

  const openAllocationManagement = (allocation) => {
    // let currentStep = stateData.currentStep;
    //   currentStep =
    //     currentStep >= stateData.totalSteps - 1
    //       ? stateData.totalSteps
    //       : currentStep + 1;
    //   setStateData({ ...stateData, currentStep: currentStep });
    //   setFormData({ ...formData, ["isStepSubmitted"]: false });
    handleChange({["selectedAllocationToManage"] : allocation});
    setStateData({ ...stateData, currentStep: 4 });
    setIsShowSaveChanges(false);
  };

  const next = () => {
    if (stateData.isCurrentStepValid) {
      // let currentStep = stateData.currentStep;
      // currentStep =
      //   currentStep >= stateData.totalSteps - 1
      //     ? stateData.totalSteps
      //     : currentStep + 1;
      // setStateData({ ...stateData, currentStep: currentStep });
      // setFormData({ ...formData, ["isStepSubmitted"]: false });
      
      let localIsFobSkipped = false;

      setStateData({ ...stateData, currentStep: 1 });

      let selectedSite = selectedSites.find(site => site.id === formData.site);
      if (!selectedSite?.isFobsSupported) {
        setIsFobSkipped(true);
        localIsFobSkipped = true;
      }
      else {
        setIsFobSkipped(false);
        localIsFobSkipped = false;
      }


      setIsShowSaveChanges(false);

      if (!localIsFobSkipped) {
        // // fob supported
        store.dispatch(commonActions.setShowFobScannerInput(true)); // dif 
        store.dispatch(commonActions.setShowScanFobButton(false));
        store.dispatch(commonActions.setShowAssigneFobOptions(false)); // dif 
        store.dispatch(commonActions.setAssigneOption(null)); 
        store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      }
      else {
        // fob not supported
        store.dispatch(commonActions.setShowFobScannerInput(false));
        store.dispatch(commonActions.setShowScanFobButton(false));   
        store.dispatch(commonActions.setShowAssigneFobOptions(true)); // dif 
        store.dispatch(commonActions.setAssigneOption(null));       

        handleChange({
          ["showTemporaryTokenPreview"] : true
        });
        
        store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      }

      // if (stateData.currentStep === ADD_PARKING_ALLOCATION_STEPS.USER_TYPE) {
      //   // not supported
      //   if (!selectedSite?.isFobsSupported) {
      //     setIsFobSkipped(true);
      //     store.dispatch(commonActions.setShowScanFobButton(false));
      //     store.dispatch(commonActions.setShowAssigneFobOptions(true));
      //   } else {
      //     setIsFobSkipped(false);
      //     store.dispatch(commonActions.setShowScanFobButton(true));
      //     store.dispatch(commonActions.setShowAssigneFobOptions(false));
      //   }
      //   store.dispatch(commonActions.setShowFobScannerInput(false));
      //   store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      //   store.dispatch(commonActions.setAssigneOption(null));
      // }
    }
         
  };

  const prev = () => {
    let currentStep = stateData.currentStep;

    if (currentStep === 4) {
      // clear selected allocation to manage, return to prev step
      handleChange({["selectedAllocationToManage"] : null});
      setStateData({ ...stateData, currentStep: 1 }); //setStateData({ ...stateData, currentStep: 3 });

      // show save changes if there is any allocations that previously added
      if (formData?.carUserTokens?.length > 0) {
        setIsShowSaveChanges(true);
      }
    }
    else {
      currentStep =
        currentStep <= stateData.totalSteps ? currentStep - 1 : currentStep;
      setStateData({ ...stateData, currentStep: currentStep });
      setFormData({ ...formData, ["isStepSubmitted"]: false });
  
      store.dispatch(commonActions.setShowScanFobButton(true));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(true));
  
      // added
      store.dispatch(commonActions.setAssigneOption(null));
      // check to set formData here
      setFormData(
        { ...formData, 
          ["foundedExistingParker"] : null,
          ["assignedParkerAllocations"] : allocations.filter(allocation => allocation.userId === props?.userData?.utronUser?.id), //props?.userData?.utronUser?.carUserTokens,
          [INPUTS_PROPS.CAR_USER_TOKEN]: [], 
          [INPUTS_PROPS.TOKENS]: [], 
          [INPUTS_PROPS.FOB] : "", // temporary - for fob supported site - new parking
          //[INPUTS_PROPS.FOB]: removeFob ? "" : formData.fob, 
          ["isStepSubmitted"]: false 
        });   // added 
  
      AssignParkerAllocationStepRef?.current?.setOccupiedTokens([]);
    }

  };

  const getStepsHeaders = () => {
    let stepHeader = null; // when stepHeader = null, no stepHeaders to reopen (used for closing modal on the submit)
    if(stateData.currentStep === ADD_PARKER_ALLOCATION_STEPS.USER_TYPE){
      stepHeader= new StepHeaderEntity(
        Strings.STEPS_TITLES.USER_TYPE_MODAL_ADD_ALLOCATION_TITLE,
        Strings.STEPS_TITLES.USER_TYPE_MODAL_ADD_ALLOCATION_SUB_TITLE,
        Icons.NEW_PARKER,
        getAddParkingAllocationBarValue(ADD_PARKER_ALLOCATION_STEPS.USER_TYPE) 
    );
    }else if(stateData.currentStep === ADD_PARKER_ALLOCATION_STEPS.ADD_TOKENS){
      stepHeader= new StepHeaderEntity(
        Strings.STEPS_TITLES.ADD_TOKEN_MODAL_ADD_ALLOCATION_TITLE,
        "", //Strings.STEPS_TITLES.ADD_TOKEN_MODAL_ADD_ALLOCATION_SUB_TITLE,
        Icons.ADD_PARKING_ALLOCATION,
        null //getAddParkingAllocationBarValue(ADD_PARKER_ALLOCATION_STEPS.ADD_TOKENS) 
    );
    }
    else if(stateData.currentStep === ADD_PARKER_ALLOCATION_STEPS.ALLOCATION_MANAGEMENT_INFO){
      stepHeader= new StepHeaderEntity(
        Strings.STEPS_TITLES.ALLOCATION_MANAGEMENT_INFO_TITLE,
        "",
        Icons.ADD_PARKING_ALLOCATION,
        null 
    );
    }
      

    return stepHeader;
  }

  return (
    <>
    {stateData.currentStep !== firstStep && (
        <div className={classes.prev}>
          <img src={Icons.LEFT_ARROW} />
          <Button onClick={prev}>Back</Button>
        </div>
      )}
      <div className={classes.formContainer}>
      <form name="AddParkingAllocationsForm" onSubmit={handleSubmit}>
          {/*selectedSites?.length > 1 &&
            <SitesSelectInput
              label={Strings.INPUT_LABELS.FACILITY}
              id={INPUTS_PROPS.SELECTED_SITE}
              onChange={handleChange}
              list={selectedSites} // list={props.sitesList}
              sitesData={null} // added
              value={selectedSites?.length > 0 ? selectedSites[0]?.id : 0} // value={props.sitesList?.length > 0 ? props.sitesList[0].id : 0}, {props.scopesList?.length > 0 ? props.scopesList[0].id : 0}
            //   handleError={handleError}
            //   hasError={!isEmail(props.email).isValid}
            //   errorMessage={getErrorMessage(isEmail(props.email))}
            />*/}
          <UserTypeStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            stepHeader={getStepsHeaders()}
            {...formData}
          />
          {/* <AddTokensFromListStep
            isEditMode={true}
            //site={selectedSites?.id}
            
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            userTypeId={userType?.userTypeId}
            userData={props?.userData?.utronUser}
            totalSteps={stateData.totalSteps}
            {...formData}
          /> */}
          {stateData.currentStep === 1 && 
          (<AssignParkerAllocationStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleStateDataChange={handleStateDataChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            userTypeId={formData.userType}
            selectedSite={getSiteFromSiteId(selectedSites, formData.site)}
            setIsShowSaveChanges={setIsShowSaveChanges}
            isFobSkipped={isFobSkipped}
            setIsFobSkipped={setIsFobSkipped}
            ref={AssignParkerAllocationStepRef} // added
            openAllocationManagement={openAllocationManagement}
            setIsAddParkingAllocationInProcess={setIsAddParkingAllocationInProcess}
            stepHeader={getStepsHeaders()}
            {...formData}
          />)}
          {stateData.currentStep === 4 && 
          (<AllocationManagementInfoStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleStateDataChange={handleStateDataChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            userTypeId={formData.userType}
            selectedSite={getSiteFromSiteId(selectedSites, formData.site)}
            validRole={props?.userData?.validRole}
            //setIsShowSaveChanges={setIsShowSaveChanges}
            isFobSkipped={isFobSkipped}
            setIsFobSkipped={setIsFobSkipped}
            isAddAllocationProcess={formData.isAddAllocationProcess}
            //ref={AssignParkerAllocationStepRef} // added
            setIsAddParkingAllocationInProcess={setIsAddParkingAllocationInProcess}
            stepHeader={getStepsHeaders()}
            {...formData}
          />)}
          {/* <AddTokensWithFobStep
            //isEditMode={true}
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            userTypeId={formData.userType}
            //userData={props?.userData?.utronUser}
            isFobSkipped={isFobSkipped} // added
            setIsFobSkipped={setIsFobSkipped} // added
            ref={AddTokensWithFobStepRef} // added
            selectedSite={getSiteFromSiteId(selectedSites, formData.site)} // added
            setIsAddParkingAllocationInProcess={setIsAddParkingAllocationInProcess}
            setIsShowSaveChanges={setIsShowSaveChanges}
            stepHeader={getStepsHeaders()}
            {...formData}
          /> */}
        {stateData.currentStep === 2 && /*stateData.currentStep < stateData.totalSteps && stateData.currentStep <= 2 && !showExsistingParkingAllocation &&*/ (
            <div className={classes.next}>
              <EllipseButton onClick={next}>{Strings.NEXT}</EllipseButton>
            </div>
        )}

        {(isShowSaveChanges && formData?.tokens?.length > 0) &&
          <div className={classes.next}>
            <EllipseButton type="submit">{Strings.SAVE_CHANGES}</EllipseButton>
          </div>}

        </form>
      </div>
    </>
  );
};

export default AddParkerAllocationsForm;
